export const headerStyles = {
  height: "60px",
  heightPromo: "28px",
  heightMobile: "40px",
  zIndex: 10000, // $z-index-modal - 1
};
